import { axiosClient } from "../client";

const queryString = require("query-string");

const PERFORMANCE_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/loyalty/performance`;

const PERFORMANCE_INFO_DATE_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/loyalty/performance/date`;

export const fetchAllPerformanceInfo = (token, locationId, filterData, programId) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: PERFORMANCE_INFO_GET_ALL(locationId),
        query: {
          where: filterData,
          program_id: programId,
        },
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  export const fetchAllPerformanceDateInfo = (token, locationId, filterData, programId) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: PERFORMANCE_INFO_DATE_GET_ALL(locationId),
        query: {
          where: filterData,
          program_id: programId,
        },
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
